
import { Coin } from '../../assets/svg/Coin';
import { Coins } from '../../assets/svg/Coins';

type OfferIconProps = {
    offerType: 'CASH' | 'REQUESTED_CONSOLIDATION' | 'MAX_CONSOLIDATION';
};

const OfferIcon = ({ offerType }: OfferIconProps) => {
    switch (offerType) {
        case 'CASH':
            return <Coin />;
        case 'REQUESTED_CONSOLIDATION':
        case 'MAX_CONSOLIDATION':
            return <Coins />;
        default:
            return undefined;
    }
};

export default OfferIcon;
